// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2ll7W","row":"ProcedureTreatmentSummary_row__3eCfL"};